import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { GetUserRolesResponse } from '@/backend/market'
import { UserRoleEntity } from '../../domain/entities/UserRoleEntity'

export class UserRoleModel extends UserRoleEntity {
  constructor(dataDto: GetUserRolesResponse) {
    super()
    mapEntityProperties<UserRoleModel>(this, dataDto)
  }
}
